export default {
  title: 'Paramètres',
  tabs: {
    details: 'Détails',
    personalization: 'Personnalisation',
    managers: 'Administrateurs',
    advanced: 'Paramètres avancés',
    translation: 'Traductions',
    integration: 'Intégration'
  },
  actions: {
    save: 'Enregistrer'
  },
  information: {
    title: 'Informations du site',
    name: 'Nom',
    description: 'Description',
    key: 'Secret',
    encryption: 'Encryption method',
    timezone: 'Fuseau horaire'
  },
  contact: {
    title: 'Contact du site',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'Email',
    phone: 'Phone'
  },
  media: {
    title: 'Medias Default',
    message: 'Vous pouvez télécharger des images pour choisir les médias défaut pour ce site.',
    badges: 'Badges',
    users: 'Users',
    button: 'Télécharger',
    buttonmessage: 'JPG/PNG (max: 3mo)'
  },
  authentication: {
    title: 'Authentification'
  },
  personalization: {
    title: 'Personnalisation'
  },
  languages: {
    title: 'Languages',
    en: 'Anglais',
    fr: 'Français',
    sp: 'Espagnol',
    ro: 'Roumain'
  },
  ip: {
    title: 'IP de confiance'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/settings.js